















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Footer extends Vue {
	@Prop({type: Boolean, default: false})
	isSite!: boolean;
}
